import type { Branded } from "@@/utilities/branded";
import { shortId } from "@@/utilities/generate-id";
import { z } from "zod";

type PageSlug = Branded<string, "PageSlug">;
const pageSlugZodSchema = z.string() as unknown as z.ZodSchema<PageSlug>;

const uniquifyPageSlug = (pageSlug: PageSlug): PageSlug => {
    const newPageSlug = `${pageSlug}-${shortId(4).toLowerCase()}` as PageSlug;
    return newPageSlug;
};

export { pageSlugZodSchema, uniquifyPageSlug };
export type { PageSlug };
